import { getIsFriesland } from './config';
import TRANSLATIONS from 'shared/translations.json';

type TranslationKey = keyof typeof TRANSLATIONS;

export const translate = (key: TranslationKey) => {
  const isFriesland = getIsFriesland();
  return isFriesland ? TRANSLATIONS[key] : key;
};
